import Tracker from 'modules/tracking/analytics/tracker';
import config from 'config';
import { SubmitItem } from './SearchFormSubmitService';

export class TrackingService {
    public static trackInteraction(item: SubmitItem, searchFieldValue: string): Promise<void> {
        const tracker = Tracker.getInstance(config, config.trackSmartSuggest);

        return new Promise((resolve: () => void) => {
            tracker.trackEvent('findologicEvent', `Assisted Suggest Click: ${item.blockLabel}`, item.label, searchFieldValue, () => {
                tracker.trackSearch(`${config.searchFieldName}=${item.label}`, undefined, () => {
                    resolve();
                });
            });
        });
    }
}
